import React from 'react';

import { useAppContext } from '../../context';
import { ILog, IUser } from '../../globals/interfaces';
import ActionIcon from '../custom/ActionIcon';
import ViewLogs from '../logNotes/ViewLogs';
import useLogNotes from '../logNotes/useLogNotes';
import styled from 'styled-components';

interface Props {
    data: Array<ILog>;
    user: IUser;
}

export default function Log({
    data
}: Props) {

    const { handleAddNotes } = useLogNotes();

    return (
        <div>
            <FlexContainer>
                <h4>AWB Operational Activity Log</h4>
                <ActionIcon
                    type={'add'}
                    onClick={() => handleAddNotes(false)}
                />
            </FlexContainer>
            <ViewLogs
                data={data}
            />
        </div>
    );
}

const FlexContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;